import { useRef, useState } from 'react';
import { Icon } from '@frontend/icons';

type VideoBubbleProps = {
  src?: string;
  onClickPreview?: () => void;
  previewTrackingId?: string;
};

export const VideoBubble = ({ src, onClickPreview, previewTrackingId }: VideoBubbleProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  if (!src) return null;

  const handlePlayToggle = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  const handlePreview = () => {
    if (onClickPreview) {
      onClickPreview();
      return;
    }
    if (src) window.open(src, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='video-bubble-wrapper' {...(previewTrackingId ? { 'data-trackingid': previewTrackingId } : {})}>
      <video
        ref={videoRef}
        className='video-bubble-video'
        src={src}
        preload='metadata'
        playsInline
        controls={isPlaying}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onClick={(e) => {
          if (isPlaying) return;
          e.stopPropagation();
          handlePreview();
        }}
      />
      {!isPlaying && (
        <button type='button' className='video-bubble-play' onClick={handlePlayToggle} aria-label='Play video'>
          <Icon name='play' size={20} />
        </button>
      )}
    </div>
  );
};
